import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useSearchParameter from 'hooks/useSearchParameter';
import useFetchUserAnalysis from 'actions/users/useFetchUserAnalysis';
import { useFetchMyUpcomingMeetings } from 'actions/meetings/fetchMyUpcomingMeetings';
import { getAgentElement } from './mindsetAI';
import { useFetchFormattedCalendarData } from './useFetchFormattedCalendarData';
import { useFetchUserProfile } from 'actions/userProfile';
export function useMindsetLocationContext(isInitialized, containerId) {
  var _userAnalysis$userMee;
  var extraContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];

  // Fetch the latest user analysis to determine if we have meeting analysis available
  var _useFetchUserAnalysis = useFetchUserAnalysis({}),
    userAnalysis = _useFetchUserAnalysis.data,
    isLoadingUserAnalysis = _useFetchUserAnalysis.isLoading;
  var hasMeetingAnalysis = Boolean(userAnalysis === null || userAnalysis === void 0 || (_userAnalysis$userMee = userAnalysis.userMeetings) === null || _userAnalysis$userMee === void 0 ? void 0 : _userAnalysis$userMee.length);
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data;
  var calendarSettings = useFetchFormattedCalendarData();
  var _useFetchMyUpcomingMe = useFetchMyUpcomingMeetings(),
    upcomingMeetings = _useFetchMyUpcomingMe.data,
    isLoadingUpcomingMeetings = _useFetchMyUpcomingMe.isLoading;
  useEffect(function () {
    if (!isInitialized) return;
    var agentEl = getAgentElement(containerId);
    if (!(agentEl !== null && agentEl !== void 0 && agentEl.setSituationalAwareness)) return;
    var context = _objectSpread({
      currentRoute: pathname,
      calendarSettings: JSON.stringify(calendarSettings !== null && calendarSettings !== void 0 ? calendarSettings : null),
      userProfile: JSON.stringify(userProfile !== null && userProfile !== void 0 ? userProfile : null)
    }, extraContext);
    if (!isLoadingUserAnalysis) {
      context.hasMeetingAnalysis = String(hasMeetingAnalysis);
    }
    if (!isLoadingUpcomingMeetings) {
      var _upcomingMeetings$has;
      context.hasUpcomingMeeting = String((_upcomingMeetings$has = upcomingMeetings === null || upcomingMeetings === void 0 ? void 0 : upcomingMeetings.hasUpcomingMeeting) !== null && _upcomingMeetings$has !== void 0 ? _upcomingMeetings$has : false);
    }
    if (pathname.startsWith('/search') && q) {
      context.searchQuery = q;
    }
    agentEl.setSituationalAwareness(context);
  }, [pathname, q, isInitialized, containerId, extraContext, hasMeetingAnalysis, isLoadingUserAnalysis, upcomingMeetings, isLoadingUpcomingMeetings, calendarSettings, userProfile]);
}